var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgSun = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 25",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.915 17.735a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM12.915 1.735v2m0 18v2m-8.48-19.48 1.42 1.42m14.12 14.12 1.42 1.42m-19.48-8.48h2m18 0h2m-19.48 8.48 1.42-1.42m14.12-14.12 1.42-1.42",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export default SvgSun;